module.exports = __webpack_public_path__ + "static/media/pattern-tree.5359fce6.svg";